import { IGenericSelectOption } from "./../shared/types/forms";

export enum DataTypes {
	select = "select",
	number = "number",
	string = "string",
	date = "date",
	slot = "slot",
	vue = "vue", //deprecated soon
	angular = "angular"
}

export interface ColumnHeader {
	header: string;
	headerGroup?: number;
	headerGroupLabel?: string;
}

export interface ColumnDisplay {
	show?: boolean;
	showForLargeScreen?: boolean;
	showForMediumScreen?: boolean;
	showForSmallScreen?: boolean;
	fixed?: boolean;
	style?: { [cssRule: string]: string };
	cellStyle?:  { [cssRule: string]: string };
}

export interface ColumnExtensions {
	sortable?: boolean;
	sortField?: string;
	tooltip?: string;
	tooltipIcon?: string; // check tooltip component for valid strings
	tooltipSize?: string;
}

export interface ColumnData {
	dataType: DataTypes;
	dataUnit?: string;
	dataUnitPosition?: string;
	formatNumber?: boolean;
	formatNumberLang?: string;
	formatNumberDecimal?: number;
	arrow?: boolean;
	signed?: boolean;
	colored?: boolean;
	searchable?: boolean;
	selectOptions?: IGenericSelectOption[];
	// tslint:disable-next-line:max-line-length
	dataDateFormat?: { [key: string]: any }; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
	dataDateLocale?: string; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
}

// tslint:disable-next-line:variable-name
export const Locale = {
	advancedSearchPlaceholder: "Search",
	columnFilterLabel: "Show/Hide columns:",
	columnFilterCheckedText: "columns",
	expandableRowLabel: "Expand row",
	globalSearchPlaceholder: "Search",
	sortLabel: "Sort",
	sortUpLabel: "Sort up",
	sortDownLabel: "Sort down",
	paginationPreviousLabel: "Prev.",
	paginationNextLabel: "Next",
	paginationFirstLabel: "First page",
	paginationLastLabel: "Last page",
	paginationDisplayLabel: "Display",
	downloadDataAsJSONLabel: "Download data as JSON",
	downloadDataAsCSVLabel: "Download data as CSV",
	copyDataLabel: "Copy visible data to clipboard",
	copiedSuccessfulMessage: "Data copied to clipboard!"
};

// NOTE: excessive slotting & dynamic components in Vue cannot be ported over to Angular.
// Has been converted to use slots instead with some disadvantages.
// NOTE: type has been removed on cells because of its nature to
// hold two distinct values which causes way too many headaches.
// Maybe architecture can be changed in the future, but for now,
// mirros Vue counterpart.
export interface Row {
	id: string;
	cells: any[];
	checked?: boolean;
	expandableTemplate?;
}
